import Vue from 'vue';
const state = {
    packaging: {},
    packagings: [],
}
const actions = {
    showPackagings: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/packagings`).then(response => {
                context.commit('SHOW_PACKAGINGS', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showPackaging: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/packagings/${id}`).then(response => {
                context.commit('SHOW_PACKAGING', response.data.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    storePackaging: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/packagings`, payload).then(response => {
                context.commit('STORE_PACKAGING', response.data)
                context.dispatch('showPackagings')
                Vue.$toast.success("Pacote cadastrado!");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updatePackaging: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/packagings/${payload.id}`, payload).then(response => {
                context.dispatch('showPackaging', payload.id)
                context.dispatch('showPackagings')
                Vue.$toast.info("Pacote atualizado");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    destroyPackaging: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/packagings/${id}`).then(response => {
                context.dispatch('showPackagings')
                Vue.$toast.error("Pacote deletado!");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
const mutations = {

    SHOW_PACKAGING: (state, payload) => {
        state.packaging = payload
    },
    SHOW_PACKAGINGS: (state, payload) => {
        state.packagings = payload
    },
    STORE_PACKAGING: (state, payload) => {
        state.packaging = payload
    }
}
const getters = {
    packaging: state => {
        return state.packaging
    },
    packagings: state => {
        return state.packagings
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}